import { useLocation } from "react-router-dom";
import { PATHNAME_CHECKER } from "@brandclub/common-ui";

export interface PageContext {
  pageType: "pdp" | "brand" | "brandclub" | "other";
  stacklineSku?: string;
}

/**
 * Hook to detect the current page context and extract relevant information
 * like stacklineSku for PDP pages
 */
export const usePageContext = (): PageContext => {
  const location = useLocation();
  const pathname = location.pathname;

  // Check for PDP patterns:
  // - /pdp/{stacklineSku} (via PATHNAME_CHECKER)
  // - /p/{stacklineSku}/product (with or without product title prefix)
  // - /{product-title}/p/{stacklineSku}/product
  const pdpMatch = PATHNAME_CHECKER.isPDP(pathname);
  const pPattern = /\/p\/([^/]+)\/product/i; // Match /p/{sku}/product anywhere in path
  const pMatchResult = pathname.match(pPattern);
  
  if (pdpMatch || pMatchResult) {
    // Extract stacklineSku from various URL patterns
    const pdpPattern = /^\/pdp\/([^/]+)/i;
    const pdpMatchResult = pathname.match(pdpPattern);
    
    const stacklineSku = pdpMatchResult?.[1] || pMatchResult?.[1];
    
    if (stacklineSku) {
      return {
        pageType: "pdp",
        stacklineSku,
      };
    }
  }

  // Check if we're on a brand page
  if (PATHNAME_CHECKER.isBrandPage(pathname)) {
    return {
      pageType: "brand",
    };
  }

  // Check if we're on a brandclub page
  if (PATHNAME_CHECKER.isBrandclubPage(pathname)) {
    return {
      pageType: "brandclub",
    };
  }

  return {
    pageType: "other",
  };
};

